// extracted by mini-css-extract-plugin
export default {"item":"All_item__XV62b","item-wp":"All_item-wp__Ecii9"};